export default __webpack_public_path__ + "static/screeny-110-gc-5-1a80169965dfbbf463a57cf60077bf5b.jpg";